export default __webpack_public_path__ + "static/media/featured2.237d68e1.png";